import { takeLatest, put, call } from 'redux-saga/effects'
import * as CONST from 'Reducers/Ambassador/const'
import { apiClient } from 'Module/API/Client'

import NProgress from 'nprogress'

import { callApi } from 'Reducers/apiCall'
import * as ERRORS from 'Reducers/Errors/const'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

import { authorization } from 'Module/Auth/Auth'
import { updateUserData } from 'Module/graphQL'

/**
 * Get ambassadors by city id
 */
function* getAmbassadorsByCityId(action) {
  NProgress.start()

  const response = yield callApi(
    apiClient.getAmbassadorsByCityId,
    action.clientId,
  )
  const responseJson = yield response.json()
  if (response.ok) {
    yield put({
      type: CONST.GET_AMBASSADORS_BY_CITY_ID_SUCCESS,
      payload: {
        ambassadorsByCityId: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get ambassador by id
 */
function* getAmbassadorById(action) {
  const response = yield callApi(
    apiClient.getAmbassadorById,
    action.ambassadorId,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_AMBASSADOR_BY_ID_SUCCESS,
      payload: {
        ambassadorById: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
}

/**
 * Upload ambassador document
 */
function* uploadAmbassadorDocument(action) {
  const { payload, ambassadorId, callbacks = {} } = action

  try {
    yield put(incUIBlockCounter())
    const response = yield call(
      apiClient.uploadAmbassadorDocument,
      ambassadorId,
      payload,
    )

    yield put({
      type: CONST.UPLOAD_AMBASSADOR_DOCUMENT_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess(response)
  } catch (ex) {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: ex,
    })
  }
  yield put(decBlockCounter())
}

/**
 * Update ambassador by id
 */
function* updateAmbassadorById(action) {
  const { ambassadorId, callbacks = {}, payload } = action
  const response = yield callApi(
    apiClient.updateAmbassadorById,
    ambassadorId,
    payload,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.UPDATE_AMBASSADOR_BY_ID_SUCCESS,
      payload: {
        ambassadorById: responseJson,
      },
    })

    callbacks.onSuccess && callbacks.onSuccess()
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
}

/**
 * Update ambassador by id
 */
function* updateAmbassadorByIdGraphQL(action) {
  const { ambassadorId, callbacks = {}, payload } = action
  const authToken = yield authorization.getAPIKey()
  const response = yield updateUserData(authToken, ambassadorId, payload)
  const responseJson = yield response.json()

  if (!responseJson.errors) {
    yield put({
      type: CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS,
      payload: {
        ambassadorById: responseJson.data.updateUserData.user,
      },
    })

    callbacks.onSuccess && callbacks.onSuccess()
  } else {
    yield put({
      type: CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_ERROR,
    })
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson.errors[0],
    })
  }
}

/**
 * Get ambassador documents by id
 */
function* getAmbassadorDocumentsById(action) {
  const response = yield callApi(
    apiClient.getAmbassadorDocumentsById,
    action.ambassadorId,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS,
      payload: {
        ambassadorDocumentsById: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
}

/**
 * Create ambassador documents by id
 */
function* createAmbassadorDocumentsById(action) {
  const { ambassadorId, payload, callbacks = {} } = action

  const response = yield callApi(
    apiClient.createAmbassadorDocumentsById,
    ambassadorId,
    payload,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.CREATE_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS,
    })
    callbacks.onSuccess && callbacks.onSuccess()
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
    callbacks.onError && callbacks.onError()
  }
}

/**
 * Get ambassador inventory by id
 */
function* getAmbassadorActivitiesById(action) {
  const response = yield callApi(
    apiClient.getAmbassadorActivitiesById,
    action.ambassadorId,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_AMBASSADOR_ACTIVITIES_SUCCESS,
      payload: {
        ambassadorActivitiesById: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
}

/**
 * Set ambassador status
 */
function* setAmbassadorStatus(action) {
  const response = yield callApi(
    apiClient.setAmbassadorStatus,
    action.ambassadorId,
    action.ambassadorStatus,
  )
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_AMBASSADOR_BY_ID_SUCCESS,
      payload: {
        ambassadorById: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }
}

/**
 * Get ambassadors by city id
 */
export function* watchGetAmbassadorsByCityId() {
  yield takeLatest(CONST.GET_AMBASSADORS_BY_CITY_ID, getAmbassadorsByCityId)
}

/**
 * Get ambassador by id
 */
export function* watchGetAmbassadorById() {
  yield takeLatest(CONST.GET_AMBASSADOR_BY_ID, getAmbassadorById)
}

export function* watchuploadAmbassadorDocument() {
  yield takeLatest(CONST.UPLOAD_AMBASSADOR_DOCUMENT, uploadAmbassadorDocument)
}
/**
 * Update ambassador by id
 */
export function* watchUpdateAmbassadorById() {
  yield takeLatest(CONST.UPDATE_AMBASSADOR_BY_ID, updateAmbassadorById)
}

/**
 * Update ambassador by id using GpahQL
 */
export function* watchUpdateAmbassadorByIdGpaphQL() {
  yield takeLatest(
    CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL,
    updateAmbassadorByIdGraphQL,
  )
}

/**
 * Get ambassador documents by id
 */
export function* watchGetAmbassadorDocumentsById() {
  yield takeLatest(
    CONST.GET_AMBASSADOR_DOCUMENTS_BY_ID,
    getAmbassadorDocumentsById,
  )
}

/**
 * Create ambassador documents by id
 */
export function* watchCreateAmbassadorDocumentsById() {
  yield takeLatest(
    CONST.CREATE_AMBASSADOR_DOCUMENTS_BY_ID,
    createAmbassadorDocumentsById,
  )
}

/**
 * Get ambassador activities by id
 */
export function* watchGetAmbassadorActivitiesById() {
  yield takeLatest(CONST.GET_AMBASSADOR_ACTIVITIES, getAmbassadorActivitiesById)
}

/**
 * Set ambassador status
 */
export function* watchSetAmbassadorStatus() {
  yield takeLatest(CONST.SET_AMBASSADOR_STATUS, setAmbassadorStatus)
}
